export const TITLE = {
    BILINGUAL: 'Bilingual',
};

export const LITERACY_LEVEL = {
    DEVELOPING: 'Developing',
    EMERGING: 'Emerging',
    ON_TRACK: 'On Track',
};

export const SORT_DIRECTIONS = {
    DESC: 'descending',
    ASC: 'ascending',
};

export const MAX_NUMBER_OF_CHARS_IN_ONE_ROW = 20;

export const NO_DATA_MESSAGES = {
    OVERALL:
        'Assessment results in both English and Spanish for a given skill are required for recommendations.',
    TRC: 'For comprehension recommendations, assess the student in both TRC and TRC Español.',
};
